import { render, staticRenderFns } from "./StageConsignmentSent.vue?vue&type=template&id=685c58b0&"
import script from "./StageConsignmentSent.vue?vue&type=script&lang=ts&"
export * from "./StageConsignmentSent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports